import HomepageRecette from './HomepageRecette';

export default HomepageRecette;
